import React from 'react';
import { Link } from 'react-router-dom';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * GatedToolCard - Phase 3.0 Soft Tool Gating
 * 
 * Wraps tool cards with conditional gating based on setup state.
 * When setup is incomplete:
 * - Reduces opacity to 0.6
 * - Disables pointer events
 * - Shows tooltip on hover explaining how to unlock
 */
const GatedToolCard = ({ 
  children, 
  to, 
  setupComplete,
  className = '',
  disabled = false
}) => {
  const isGated = !setupComplete && !disabled;

  if (isGated) {
    return (
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <div 
              data-testid="gated-tool-card"
              className={`${className} opacity-60 cursor-not-allowed`}
              style={{ pointerEvents: 'auto' }}
            >
              <div className="pointer-events-none">
                {children}
              </div>
            </div>
          </TooltipTrigger>
          <TooltipContent 
            side="top" 
            className="bg-[#2c2c2c] border-amber-500/50 text-white px-3 py-2"
          >
            <p className="text-sm">Complete machine setup to activate this tool.</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  // When setup is complete, render as normal Link
  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
};

export default GatedToolCard;
